import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';
import { GeneralASError } from 'src/registry/types/axios';
import { Discount } from 'src/features/discounts/utils/types';
import { DiscountFormSchemaValues } from 'src/features/discounts/utils/formSchema';

const RESOURCE = '/discounts/discount/:discountId/';

type MutationFnType = typeof mutationFn;

interface DTO extends DiscountFormSchemaValues {
    discountId: string;
}
const mutationFn = ({ discountId, ...data }: DTO): Promise<Discount> => {
    return axios.put(formatResourcePath(RESOURCE, { discountId }), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralASError> = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useUpdateDiscount };
